import API from 'services/API';

export default function getNotificationsSettings() {
  return API.request({
    method: 'GET',
    url: '/notification/subscriptions',
  });
}
